import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  adminStorefrontSetupViewAccessControl,
  mobileManagementViewAccessControl,
  onboardingSiteSetupAccessControl,
} from '../access-control/onboardingAccess.configuration'

const OnboardingSiteOverviewPage = lazy(
  () => import('../pages/site-overview/OnboardingSiteOverviewPage')
)
const MobileDashboardPage = lazy(() => import('../pages/mobile-dashboard/MobileDashboardPage'))
const OnboardingSiteSetupFormAdminPage = lazy(
  () => import('../pages/site-setup-form-admin/OnboardingSiteSetupFormAdminPage')
)
const OnboardingSiteSetupAdminPage = lazy(
  () => import('../pages/site-setup-admin/OnboardingSiteSetupAdminPage')
)
const MobileAppDetailPage = lazy(() => import('../pages/mobile-app-detail/MobileAppDetailPage'))
const FlipDashboardPage = lazy(() => import('../pages/flip-dashboard/FlipDashboardPage'))
const FlipSiteDetailPage = lazy(() => import('../pages/flip-dashboard/FlipSiteDetailPage'))
const FlipFeatureDetailPage = lazy(() => import('../pages/flip-dashboard/FlipFeatureDetailPage'))
// @hygen:inject page-import

export const onboardingAdminRouter = (
  <DomainRoute route="app-admin-onboarding">
    <DashSwitch>
      <DomainRoute
        accessControl={adminStorefrontSetupViewAccessControl}
        exact
        route="app-admin-onboarding-site-overview"
        component={OnboardingSiteOverviewPage}
      />
      <DomainRoute
        accessControl={mobileManagementViewAccessControl}
        exact
        route="app-admin-onboarding-mobile-dashboard"
        component={MobileDashboardPage}
      />
      <DomainRoute
        accessControl={adminStorefrontSetupViewAccessControl}
        exact
        route="app-admin-onboarding-site-setup-form-admin"
        component={OnboardingSiteSetupFormAdminPage}
      />
      <DomainRoute
        accessControl={adminStorefrontSetupViewAccessControl}
        exact
        route="app-admin-onboarding-site-setup-admin"
        component={OnboardingSiteSetupAdminPage}
      />
      <DomainRoute
        accessControl={mobileManagementViewAccessControl}
        exact
        route="app-admin-onboarding-mobile-app-detail"
        component={MobileAppDetailPage}
      />
      <DomainRoute
        accessControl={onboardingSiteSetupAccessControl}
        exact
        route="app-admin-onboarding-flip-feature-detail"
        component={FlipFeatureDetailPage}
      />
      <DomainRoute
        accessControl={onboardingSiteSetupAccessControl}
        exact
        route="app-admin-onboarding-flip-site-detail"
        component={FlipSiteDetailPage}
      />
      <DomainRoute
        accessControl={onboardingSiteSetupAccessControl}
        exact
        route="app-admin-onboarding-flip-dashboard"
        component={FlipDashboardPage}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
